import ManageCard from '../../../../banking/components/cards/ManageCard';

const ManageCardScreen = () => {
    return <ManageCard />;
};

export default ManageCardScreen;
